module.exports = __webpack_public_path__ + "img/hcml_gallery5.70d1ea85.jpg";